import Vue from 'vue'
import VueRouter from 'vue-router'
import { PrevLoading } from '@/common/js/loading.js';
import BigScreenLayout from '@/components/Layout/BigScreenLayout.vue'

Vue.use(VueRouter)

// 针对ElementUI导航栏中重复导航报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'BigScreen',
    component: BigScreenLayout
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由加载后
router.afterEach((to, from) => {
	PrevLoading.done();
});

export default router